import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_9: FaireProductEntity = {
  token: "catalog_prod_prod-9",
  type: "product",
  name: "Celebration Banner - Happy Everything",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 34.08,
  msrpDollars: 85.2,
  sku: "CO0009",
  caseSize: 6,
  material: "Glass",
  collectionToken: "col_confetti-cake",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 386,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_throw-pillows"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
